import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

@connect()
export default class Header extends React.Component {
  constructor(props, context) {
    super(props, context);
    let widthOfPage = window.innerWidth;
    let title = props.title;
    this.state = {
      title: title,
      classes: props.classes || '',
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    let title = props.title;
    this.setState({
      title: title,
    });
  }

  render() {
    let titleClasses = 'title-bar ';

    let linkRenderCondition =
      this.props.showLinkCondition != null || this.props.showLinkCondition != undefined
        ? this.props.showLinkCondition
        : true;

    let titleBarMarkUpWithLink = (
      <div className="inline-flex center-flex max-width full-height min-height-for-title">
        <div className="title-bar-content max-width">
          {this.props.notRenderLogo ? (
            ''
          ) : (
            <div>
              <img className="ui image  umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo} />
              <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo} />
            </div>
          )}
          <div className="inline-flex center-flex header-content-wrapper full-height max-width">
            {this.props.children}
            {this.props.isCombinedTitle ? (
              <div className="max-width">
                <div className="ui header">
                  <span style={{ wordBreak: 'break-all' }}>{this.props.titlePart1}</span>
                  <span className={this.props.titleColor}>{this.props.titlePart2}</span>
                </div>
                <div className="inline-flex end-with-flex space-between max-width">
                  <div
                    className={'sub-header sub-header-with-link ' + this.props.subHeaderClass}
                    style={{ wordBreak: 'break-all' }}
                  >
                    {this.props.subHeader}
                  </div>
                  {this.props.linkTo && linkRenderCondition && (
                    <Link
                      className={
                        'back-to-wa-link hide-on-tablet-ress hide-on-small-ress min-width-for-link ' +
                        this.props.linkClass
                      }
                      to={this.props.linkTo}
                      onClick={this.props.linkOnClick}
                    >
                      <i className="chevron circle left icon" />
                      <span>{this.props.linkText}</span>
                    </Link>
                  )}
                </div>
              </div>
            ) : (
              <div className="max-width">
                <div className={'ui header ' + this.props.titleColor}>{this.state.title}</div>
                <div className="inline-flex end-with-flex space-between max-width">
                  <div className={'sub-header sub-header-with-link ' + this.props.subHeaderClass}>
                    {this.props.subHeader}
                  </div>
                  {this.props.linkTo && linkRenderCondition && (
                    <Link
                      className={
                        'back-to-wa-link hide-on-tablet-ress hide-on-small-ress min-width-for-link ' +
                        this.props.linkClass
                      }
                      to={this.props.linkTo}
                      onClick={this.props.linkOnClick}
                    >
                      <i className="chevron circle left icon" />
                      <span>{this.props.linkText}</span>
                    </Link>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );

    let normalTitleBarMarkUp = (
      <div className="title-bar-content">
        {this.props.notRenderLogo ? (
          ''
        ) : (
          <div>
            <img className="ui image  umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo} />
          </div>
        )}

        <div className="inline-flex center-flex header-content-wrapper full-height min-height-for-title">
          {this.props.children}
          {this.props.isCombinedTitle ? (
            <div>
              <div className="ui header">
                <span>{this.props.titlePart1}</span>
                <span className={this.props.titleColor}>{this.props.titlePart2}</span>
              </div>
              <div className={'sub-header ' + this.props.subHeaderClass}>{this.props.subHeader}</div>
            </div>
          ) : (
            <div>
              <div className={'ui header ' + this.props.titleColor}>{this.state.title}</div>
              <div className={'sub-header ' + this.props.subHeaderClass}>{this.props.subHeader}</div>
            </div>
          )}
        </div>
      </div>
    );

    let titleBarMarkUpWithLinkAndActionButtons = (
      <div className="inline-flex center-flex max-width full-height min-height-for-title">
        <div className="title-bar-content max-width mrtxs mrbxs">
          {this.props.notRenderLogo ? (
            ''
          ) : (
            <div>
              <img className="ui image  umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo} />
              <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo} />
            </div>
          )}
          {this.props.linkTo && linkRenderCondition && (
            <Link
              className={'back-to-wa-link min-width-for-link start-left ' + this.props.linkClass}
              to={this.props.linkTo}
              onClick={this.props.linkOnClick}
            >
              <i className="chevron circle left icon" />
              <span>{this.props.linkText}</span>
            </Link>
          )}
          <div className="inline-flex center-flex header-content-wrapper full-height max-width">
            {this.props.children}
            {this.props.isCombinedTitle ? (
              <div className="max-width">
                <div className="ui header header-with-button">
                  <span style={{ wordBreak: 'break-all' }}>{this.props.titlePart1}</span>
                  <span className={this.props.titleColor}>{this.props.titlePart2}</span>
                </div>
                <div className="space-between max-width">
                  <div
                    className={
                      'sub-header sub-header-with-link ' +
                      this.props.subHeaderClass +
                      (this.props.renderActionButtons ? ' sub-header-with-action' : '')
                    }
                    style={{ wordBreak: 'break-all' }}
                  >
                    {this.props.subHeader}
                    {this.props.showSubHeaderTag ? (
                      <div className="gc-tag group-consultation-pill">
                        <div className="span-like group-consultation-text" style={{ whiteSpace: 'nowrap' }}>
                          {this.props.subHeaderTagText}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  {this.props.renderActionButtons && (
                    <div className="ui actions fr header-action-button forTablet">
                      <button
                        type="button"
                        className={this.props.actionButtonClass}
                        style={this.props.actionButtonStyle}
                        onClick={this.props.actionButtonOnClick}
                      >
                        {this.props.actionButtonText}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="max-width">
                {this.props.linkTo && linkRenderCondition && (
                  <Link
                    className={'back-to-wa-link min-width-for-link start-left ' + this.props.linkClass}
                    to={this.props.linkTo}
                    onClick={this.props.linkOnClick}
                  >
                    <i className="chevron circle left icon" />
                    <span>{this.props.linkText}</span>
                  </Link>
                )}
                <div className={'ui header header-with-button ' + this.props.titleColor}>{this.state.title}</div>
                <div className="space-between max-width">
                  <div
                    className={
                      'sub-header sub-header-with-link ' +
                      this.props.subHeaderClass +
                      (this.props.renderActionButtons ? ' sub-header-with-action' : '')
                    }
                  >
                    {this.props.subHeader}
                    {this.props.showSubHeaderTag ? (
                      <div className="gc-tag group-consultation-pill">
                        <div className="span-like group-consultation-text" style={{ whiteSpace: 'nowrap' }}>
                          {this.props.subHeaderTagText}
                        </div>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  {this.props.renderActionButtons && (
                    <div className="ui actions fr header-action-button forTablet">
                      <button
                        type="button"
                        className={this.props.actionButtonClass}
                        style={this.props.actionButtonStyle}
                        onClick={this.props.actionButtonOnClick}
                      >
                        {this.props.actionButtonText}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );

    return (
      <div className={this.props.classes ? titleClasses + this.props.classes : titleClasses}>
        {this.props.linkTo
          ? this.props.renderActionButtons
            ? titleBarMarkUpWithLinkAndActionButtons
            : titleBarMarkUpWithLink
          : normalTitleBarMarkUp}
      </div>
    );
  }
}
Header.propTypes = {
  title: PropTypes.string,
};
